
export type CalendarProps = {
  events: CalendarEvent[]
  setEvents: (events: CalendarEvent[]) => void
  mode: Mode
  setMode: (mode: Mode) => void
  date: Date
  setDate: (date: Date) => void
  calendarIconIsToday?: boolean,
  
  vehicles: CalendarVehicle[],
  setVehicles: (vehicles: CalendarVehicle[]) => void,
  locations: CalendarLocation[],
  setLocations: (locations: CalendarLocation[]) => void,
  partners: CalendarPartner[],
  setPartners: (partners: CalendarPartner[]) => void,
  reservationStates: ReservationState[]
  setReservationStates: (states: ReservationState[]) => void,
}

export type CalendarContextType = CalendarProps & {
  datePickerDialogOpen: boolean;
  setDatePickerDialogOpen: (open: boolean) => void
  newEventDialogOpen: boolean
  setNewEventDialogOpen: (open: boolean) => void
  manageEventDialogOpen: boolean
  setManageEventDialogOpen: (open: boolean) => void
  selectedEvent: CalendarEvent | null
  setSelectedEvent: (event: CalendarEvent | null) => void

  locations: CalendarLocation[]
  setLocations: (locations: CalendarLocation[]) => void
  partners: CalendarPartner[]
  setPartners: (partners: CalendarPartner[]) => void
  vehicles: CalendarVehicle[]
  setVehicles: (vehicles: CalendarVehicle[]) => void
  reservationStates: ReservationState[]
  setReservationStates: (states: ReservationState[]) => void
}
export type CalendarEvent = {
  id: string
  title: string
  color: string
  start: Date
  end: Date

  // reservation details
  vehicleId?: number
  pickupId?: number
  dropoffId?: number
  partnerId?: number
  status: string
  notes?: string
  customerName?: string
  customerPhone?: string
  customerEmail?: string
  price?: number
  commission?: number // do we need to save commission amount for each reservation?
  discount?: number
}

export type CalendarVehicle = {
  id: number,
  name: string,
}

export type CalendarLocation = {
  id: number,
  name: string,
};

export type CalendarPartner = {
  id: number,
  name: string,
  commission: number,
};

export type ReservationState = {
  value: string
  label: string
  color: string
};

export const calendarModes = ['day', 'week', 'month'] as const
export type Mode = (typeof calendarModes)[number]
